import React from 'react';
import {useSelector} from 'react-redux';
import {Box} from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import {getActiveLineName} from '../../utils/lineName';

// Título de breadcrumb: línea WhatsApp activa (customer.name vive en state.agent.name).
const LineNameLabel = () => {
    const name = useSelector((state) => getActiveLineName(state.agent));

    return (
        <Box component="span" sx={{display: 'inline-flex', alignItems: 'center', gap: 1}}>
            <WhatsAppIcon sx={{fontSize: 20, color: 'success.main'}}/>
            <span>{name}</span>
        </Box>
    );
};

export default LineNameLabel;
